module.exports = __webpack_public_path__ + "img/mo.mo471093d.svg";